import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/Login.css';

const Login = () => {
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // If already authenticated, redirect to dashboard
    if (isAuthenticated) {
      navigate('/dashboard');
    }
    // Check for error in URL
    const error = searchParams.get('error');
    if (error) {
      alert(`Authentication failed: ${error}`);
    }
  }, [isAuthenticated, navigate, searchParams]);

  return (
    <div className="login-page">
      {/* Animated Background */}
      <div className="animated-background">
        <div className="circle circle-1"></div>
        <div className="circle circle-2"></div>
        <div className="circle circle-3"></div>
      </div>

      {/* Login Container */}
      <div className="login-container">
        {/* Left Side - Branding */}
        <div className="login-left">
          <div className="brand-content">
            <div className="logo-section">
              <div className="logo-icon">🎓</div>
              <h1 className="brand-name">Spardhaweb.com</h1>
            </div>
            <p className="brand-tagline">Your Gateway to Success</p>
            <div className="features-list">
              <div className="feature-item">
                <span className="feature-icon">✓</span>
                <span className="feature-text">Premium Quiz Content</span>
              </div>
              <div className="feature-item">
                <span className="feature-icon">✓</span>
                <span className="feature-text">Expert-Curated Batches</span>
              </div>
              <div className="feature-item">
                <span className="feature-icon">✓</span>
                <span className="feature-text">Track Your Progress</span>
              </div>
              <div className="feature-item">
                <span className="feature-icon">✓</span>
                <span className="feature-text">Learn at Your Pace</span>
              </div>
            </div>
          </div>
        </div>

        {/* Right Side - Login Form */}
        <div className="login-right">
          <div className="login-card">
            <div className="login-header">
              <h2 className="login-title">Welcome Back!</h2>
              <p className="login-subtitle">Sign in to continue your learning journey</p>
            </div>

            <div className="login-body">
              {/* Google Login Button */}
              <button className="google-login-btn" onClick={login}>
                <div className="google-icon-wrapper">
                  <img 
                    src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" 
                    alt="Google" 
                    className="google-icon"
                  />
                </div>
                <span className="google-btn-text">Continue with Google</span>
              </button>

              {/* Divider */}
              <div className="divider">
                <span className="divider-text">or</span>
              </div>

              {/* Alternative Login Options */}
              <div className="alternative-login">
                <p className="alt-text">Other login options coming soon...</p>
              </div>

              {/* Terms and Privacy */}
              <div className="login-footer">
                <p className="terms-text">
                  By continuing, you agree to our{' '}
                  <a href="/terms-conditions" className="terms-link">Terms of Service</a>
                  {' '}and{' '}
                  <a href="/privacy-policy" className="terms-link">Privacy Policy</a>
                </p>
              </div>
            </div>
          </div>

          {/* Additional Info */}
          <div className="signup-prompt">
            <p>Don't have an account? <span className="signup-link">Sign up is automatic with Google!</span></p>
          </div>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="decorative-elements">
        <div className="floating-icon icon-1">📚</div>
        <div className="floating-icon icon-2">🎯</div>
        <div className="floating-icon icon-3">⭐</div>
        <div className="floating-icon icon-4">🏆</div>
      </div>
    </div>
  );
};

export default Login;